// extracted by mini-css-extract-plugin
module.exports = {"personalInfo":"PersonalInfo_personalInfo__4ZOi7","links":"PersonalInfo_links__qxKi8","link":"PersonalInfo_link__K6TDS","linkIcon":"PersonalInfo_linkIcon__vvYxI"};